import { ReactElement } from "react";
import {
  AuthInfoList,
  IAuthInfo,
  IDecryptedAuthInfo,
  IEncryptedAuthInfo,
} from "../../interfaces/AuthInfo";

export enum AccountStateEnum {
  REQUIRE_CONNECT = "REQUIRE_CONNECT",
  REQUIRE_REGISTER_SIGNING = "REQUIRE_REGISTER_SIGNING",
  REQUIRE_PASSWORD = "REQUIRE_PASSWORD",
  OK = "OK",
}

/**
 * What `deleteAuthInfo` removes. `trading` clears the API key, secret AND
 * signing key in one storage write, so re-enabling trading mints a fresh API
 * key (the register call reuses a stored key when one is present).
 */
export type AuthInfoType = "api" | "signing" | "trading" | "all";

export type AuthInfoMap = Record<
  string,
  IAuthInfo | IDecryptedAuthInfo | IEncryptedAuthInfo
>;

export interface IAuthContextType {
  authInfoList: AuthInfoList;
  accountSigningKeyState: AccountStateEnum;
  accountApiKeyState: AccountStateEnum;
  manualImportAccount: (authInfo: IEncryptedAuthInfo, password: string) => void;
  manualSyncAccount: (authInfo: IDecryptedAuthInfo) => void;
  isGeoblocked?: boolean;
  getRawAccountAuthInfo: () => IAuthInfo | undefined;
  getImportedAccountAddress: () => string | null;
  account?: string | null;
  masterAccount?: string | null;
  activeSubaccount?: string;
  setActiveSubaccount: (sub: string | undefined) => void;
  isAccountImported: boolean;
  apiKey?: string;
  apiSecret?: string;
  signingKey?: string;
  expiry?: string;
  isEncryptionEnabled: boolean;
  showInvalidRefModal?: boolean;

  setAuthInfoList: (info: AuthInfoList) => void;
  encryptAccount: (password: string) => boolean;
  reconnectImportedAccount: () => void;
  unlockAccount: (password: string) => boolean;
  disconnectAccount: () => void;
  // If password is provided, encrypt the entire auth info before storing it locally
  enableTrading: (info: IAuthInfo, isRememberMeChecked: boolean) => void;
  deleteAuthInfo: (authInfo: AuthInfoType) => void;
  setShowInvalidRefModal: (show: boolean) => void;
}

export interface IAuthContextProviderProps {
  children: ReactElement;
}
